import React from "react";
import { fmtOrderRupee } from "../../pages/storeSalesDashboardHelpers";

export default function CreditNoteBalance({ balance, className = "" }) {
  const n = Number(balance);
  const label =
    Number.isFinite(n) && n >= 0
      ? `${fmtOrderRupee(n)} remaining`
      : "—";
  return (
    <span className={`fw-semibold ${className}`.trim()}>{label}</span>
  );
}
